import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 p-4 mb-4 rounded-10" }
const _hoisted_2 = { style: {"margin":"-24px -11px -15px -16px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"d-flex flex-wrap gap-2 justify-content-between align-items-center mb-1\"><h3 class=\"d-block mb-1\">Gross Revenue</h3><select class=\"form-select month-select form-control w-135 bg-border-color border-color\" aria-label=\"Default select example\"><option selected>Monthly</option><option value=\"1\">Yearly</option></select></div><div class=\"d-flex align-items-center mb-2\"><h3 class=\"fs-32 fw-bold text-secondary mb-0\">$1,528</h3><span class=\"fw-medium fs-12 text-success bg-success bg-opacity-10 border border-success px-2 rounded-pill ms-2\"> +5.4% <i class=\"ri-arrow-up-line\"></i></span></div><span class=\"fs-12 d-block mb-4\">vs previous 30 days</span>", 3)),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.isClient)
        ? (_openBlock(), _createBlock(_component_apexchart, {
            key: 0,
            type: "area",
            height: "372",
            options: _ctx.grossRevenue,
            series: _ctx.revenue
          }, null, 8, ["options", "series"]))
        : _createCommentVNode("", true)
    ])
  ]))
}